import { useContext, useEffect } from "react";
import { Box, Typography, Stack, Checkbox, Avatar, TextField } from "@mui/material"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { ValidateInt } from "../../../../../core/validator/Validator";
import { rqx } from "../../../../../core/request/API";
import { env } from "../../../../../core/Env";
import { fieldStyle } from "../../../../../core/global/realproperty/Index";

export const OtherInformation = ({ handleChange }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { otherInfrmtn, types, dfltOtherInfrmtn } = realproperty_state;
    const classes = fieldStyle();

    const readChecklists = async () => {
        if (types.data.checkListItems.length === 0) {
            try {
                const res_checklists = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "check_list" });
                if (res_checklists) {
                    types.set((p) => ({...p, checkListItems: res_checklists}))
                }
            } catch (e) {
                console.error('Failed to fetch checklists items:', e);
            }
        }
    };

    useEffect(() => {
        readChecklists();
        // eslint-disable-next-line
    }, [])
    // checkboxes for checklists handler
    const handleChecklist = (id) => (e) => {
        otherInfrmtn.set((p) => {
            const updatedChecklist = e.target.checked
                ? [...(p.checkList || []), id] // add item if checked
                : (p.checkList || []).filter((item) => item !== id); // remove if unchecked

            return {
                ...p, checkList: updatedChecklist
            };
        });
    };

    return (
        <Box>
            {types.data.checkListItems.length === 0 ? 
                <Box py="0.5rem" display="flex" alignItems="center" justifyContent="center">
                    <SnakeLoader bg="#11783C" size="7px" distance="7px" /> 
                </Box> 
            :
                <>
                    <Typography mb="0.5rem" fontWeight={600} fontSize={14}> Property Checklist </Typography>
                    {types.data.checkListItems?.map((v, i) => (
                        <Stack key={i} direction="row" alignItems="center">
                            <Checkbox size="small" onChange={handleChecklist(v.id)} checked={otherInfrmtn.data.checkList?.includes(v.id)}/>
                            <Typography>{v.name}</Typography>
                        </Stack>
                    ))}
                    <Typography mb="0.5rem" mt="1.5rem" fontWeight={400} fontSize={16}> Contact Details </Typography>
                    <Stack flexDirection="row" gap="1rem" mb="2rem">
                        <Box display="flex" alignItems="center">
                            <Avatar/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography fontWeight={600} fontSize={14} mb="0.5rem">First Name<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="firstName" value={otherInfrmtn.data.firstName.value} onChange={(e) => handleChange(e, otherInfrmtn)} error={otherInfrmtn.data.firstName.stat}  helperText={otherInfrmtn.data.firstName.stat ? dfltOtherInfrmtn.data.firstName.msg : ""} fullWidth size="small" className={classes.tf} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem" fontWeight={600} fontSize={14}>Last Name<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="lastName" value={otherInfrmtn.data.lastName.value} onChange={(e) => handleChange(e, otherInfrmtn)} error={otherInfrmtn.data.lastName.stat} helperText={otherInfrmtn.data.lastName.stat ? dfltOtherInfrmtn.data.lastName.msg : ""} fullWidth size="small" className={classes.tf} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem" fontWeight={600} fontSize={14}>Email<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="email" value={otherInfrmtn.data.email.value} onChange={(e) => handleChange(e, otherInfrmtn)} error={otherInfrmtn.data.email.stat} helperText={otherInfrmtn.data.email.stat ? dfltOtherInfrmtn.data.email.msg : ""} fullWidth size="small" className={classes.tf} InputLabelProps={{ shrink: false }}/>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography mb="0.5rem" fontWeight={600} fontSize={14}>Mobile Number<Typography component="span" color="error">*</Typography></Typography>
                            <TextField name="mobileNumber" value={otherInfrmtn.data.mobileNumber.value} onChange={(e) => handleChange(e, otherInfrmtn)} onKeyPress={ValidateInt} inputProps={{ maxLength: 11 }} error={otherInfrmtn.data.mobileNumber.stat} helperText={otherInfrmtn.data.mobileNumber.stat ? dfltOtherInfrmtn.data.mobileNumber.msg : ""} fullWidth size="small" className={classes.tf} InputLabelProps={{ shrink: false }}/>
                        </Box>
                    </Stack>
                </>
            }
        </Box>
    )
}
